/*
Replace
certificate with your resource Name :) Take care about different writings!
/!\ Certificate certificate Certificates certificates /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const certificateSlice = createSlice({
  name: "certificates",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
  },
});

export const {
  list: listCertificates,
  show: showCertificate,
  create: createCertificate,
  update: updateCertificate,
} = certificateSlice.actions;

export const actions = certificateSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const certificates = (state) =>
  state.certificates.idsList.map((id) => state.certificates.dictionary[id]);
export const certificate = (state) =>
  state.certificates.showId &&
  state.certificates.dictionary[state.certificates.showId];
export const certificateAttributes = (state) => certificate(state)?.attributes;
export const certificateRelationships = (state) =>
  certificate(state)?.relationships;
export const certificateId = (state) => state.certificates.showId;

export const getCertificate = createSelector(
  (state) => state.certificates.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getCertificateAttributes = createSelector(
  (state) => state.certificates.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getCertificateRelationships = createSelector(
  (state) => state.certificates.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getCertificates = createSelector(
  (state) => state.certificates.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export default certificateSlice.reducer;
